export const changedeliveryDateReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_DELIVERY_DATE":
        return action.payload.deliveryDate;
      default:
        return state;
    }
  };
  